import React, { useEffect, useState } from 'react';
import ControlledInvoiceRecipientApproval from './ControlledInvoiceRecipientApproval';

const phases = {
  review: 'Prüfung erforderlich', prepared: 'Zur Erstellung vorgemerkt',
  create_requested: 'Erstellung eingeleitet – Ergebnis prüfen', draft: 'Entwurf wird geprüft',
  finalize_requested: 'Festschreibung eingeleitet – Ergebnis prüfen', finalized: 'Festgeschrieben',
  send_requested: 'Versand eingeleitet – Ergebnis prüfen', sent: 'Versendet',
};

export default function ControlledInvoiceReview({ token, active }) {
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    if (!active || !token) return undefined;
    setResult(null);
    setError('');
    const controller = new AbortController();
    let disposed = false;
    const timeout = setTimeout(() => controller.abort(), 12000);
    fetch(`${process.env.REACT_APP_API_URL || '/api'}/admin/controlled-invoices`, {
      headers: { Authorization: `Bearer ${token}` }, signal: controller.signal,
    }).then(async response => {
      if (!response.ok) throw new Error('Die Rechnungsprüfung konnte nicht geladen werden.');
      const data = await response.json();
      if (typeof data?.enabled !== 'boolean' || !Array.isArray(data.items)) throw new Error('Invalid response');
      if (!controller.signal.aborted) { setResult(data); setError(''); }
    }).catch(() => { if (!disposed) setError('Die Rechnungsprüfung konnte nicht geladen werden. Bitte erneut versuchen.'); })
      .finally(() => clearTimeout(timeout));
    return () => { disposed = true; clearTimeout(timeout); controller.abort(); };
  }, [active, token, refresh]);
  if (!active || (!error && !result?.enabled && !result?.approval_enabled)) return null;
  return <div className="card" aria-label="Kontrollierte Rechnungen">
    <h3>Kontrollierte Rechnungen</h3>
    <button type="button" onClick={() => setRefresh(value => value + 1)}>Rechnungsprüfung aktualisieren</button>
    <p>Freigegebene Rechnungsempfänger pro Vertrag. Unklare Vorgänge werden angehalten; Zahlungen und Kundenzugänge bleiben unverändert.</p>
    {result?.approval_enabled && !error && <ControlledInvoiceRecipientApproval token={token} />}
    {error && <p role="alert">{error}</p>}
    {result?.health?.failures > 0 && <p role="alert">Der letzte Anbieterabgleich war unvollständig. Bitte technisch prüfen; fehlende Rechnungen sind nicht ausgeschlossen.</p>}
    {!error && result?.enabled && !result?.items?.length && <p>Keine offenen Rechnungsvorgänge.</p>}
    {(!error ? result?.items || [] : []).map(item => <article key={item.id} style={{ padding: '12px 0', borderTop: '1px solid #ddd' }}>
      <strong>{item.customer}</strong><p>{phases[item.phase] || 'Unbekannter Status – prüfen'}</p>
      {item.kind === 'recipient_review' && <p role="alert">Der Vertrag ist wegen ungeklärter Rechnungsempfängerdaten vom Writer ausgeschlossen. Empfänger, Firmenzuordnung und Anbieter-Ausschluss müssen kontrolliert vorbereitet werden.</p>}
      {item.error_code && item.kind !== 'recipient_review' && <p role="alert">Manuelle Prüfung erforderlich. Bitte keinen zweiten Beleg erstellen und keinen Versand ungeprüft wiederholen.</p>}
      {item.request_id && <small>Adressanfrage: {item.request_id}<br /></small>}
      {item.kind !== 'recipient_review' && <small>Vorgang: {item.id}</small>}
    </article>)}
    {result?.total > result?.items?.length && <p>Es werden die neuesten 100 offenen Vorgänge angezeigt. Weitere Vorgänge sind vorhanden.</p>}
  </div>;
}
